import Mezzo from '@/png/landing/site-references/mezzo-logo.png'
import Tog from '@/png/landing/site-references/tog-logo.png'
import PanAir from '@/png/landing/site-references/pan-air-travel-logo.png'
import Vicchi from '@/png/landing/site-references/vicchi-logo.png'
import Monster from '@/png/landing/site-references/monster-logo.png'

export const SITE_REFERENCE = [
  {
    src: Mezzo,
    alt: 'mezzo logo',
    width: 120,
    height: 111,
  },
  {
    src: Tog,
    alt: 'TOG logo',
    width: 180,
    height: 67,
  },
  {
    src: PanAir,
    alt: 'Pan air travel logo',
    width: 110,
    height: 110,
  },
  {
    src: Vicchi,
    alt: 'Vicchi logo',
    width: 120,
    height: 119,
  },
  {
    src: Monster,
    alt: 'Atimedesign logo',
    width: 140,
    height: 140,
  },
]
